// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__gJbBy","dragIcon":"Choice_dragIcon__W-NBg","left":"Choice_left__1eoCu","input":"Choice_input__3gRCr"};